import React, { useState, useEffect } from 'react'
import { ThemeProvider } from '@emotion/react'
import * as styles from '../styles/exports.module.scss'
import AppContext from './context'
import Nav from './nav'
import Footer from './footer'
import SearchProvider from './search-provider'

export default function Layout({ children }) {
    const [clientWidth, setClientWidth] = useState(typeof document !== `undefined` ? document.body.clientWidth : null) // excludes scrollbar width
    const [screenWidth, setScreenWidth] = useState(typeof window !== `undefined` ? window.screen.width : null) // includes scrollbar width
    const [screenHeight, setScreenHeight] = useState(typeof window !== `undefined` ? window.screen.height : null)
    const [overlay, setOverlay] = useState('')
    const [subMenu, setSubmenu] = useState('')
    
    useEffect(() => {
        if(typeof window === 'undefined') return

        const handleResize = e => {
            setClientWidth(e.target.document.body.clientWidth)
            setScreenWidth(e.target.screen.width)
            setScreenHeight(e.target.screen.height)
        }
        
        window.addEventListener('resize', handleResize)
        
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    
    useEffect(() => {
        if(typeof document === 'undefined') return

        const handleCloseOverlay = ({ target }) => {
            if(!overlay) return

            const mainOverlay = target.closest('#main-overlay')
            const mobileOverlay = target.closest('#mobile-overlay')
            
            const input = target.closest('input')
            const button = target.closest('button')
            const img = target.closest('img')

            if(input || button || img) return
            if(!mainOverlay && !mobileOverlay) setOverlay('')
        }

        const handleKeydown = ({ key }) => {
            if(!overlay) return
            if (key === 'Escape') setOverlay('')
        }
        
        document.addEventListener('click', handleCloseOverlay)
        document.addEventListener('keydown', handleKeydown)

        if(!overlay) setSubmenu('')
        
        return () => {
            document.removeEventListener('click', handleCloseOverlay)
            document.removeEventListener('keydown', handleKeydown)
        }
    }, [overlay])

    const value = {
        clientWidth,
        screenWidth,
        screenHeight,
        overlay, setOverlay,
        subMenu, setSubmenu,
    }

    // https://emotion.sh/docs/theming
    const theme = {
        colors: {
            primary: styles.primaryColor,
            secondary: styles.secondaryColor,
            mutedLight: styles.mutedLight,
            mutedDark: styles.mutedDark,
        },
        fonts: {
            primary: styles.primaryFont,
            secondary: styles.secondaryFont
        }
    }
    
    /**
     * Nav and main need separate SearchProviders in order to separate their state.
     * e.g. nav hover doesn't affect listing page results.
     */
    return (
        <AppContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                    <SearchProvider>
                        <Nav />
                    </SearchProvider>
                    <SearchProvider>
                        <main>{children}</main>
                    </SearchProvider>
                    <Footer />
            </ThemeProvider>
        </AppContext.Provider>
    )
}
